import React from 'react'
import DropdownContainer from '../../../Components/UiKits/Dropdown'

export default function Dropdown() {
  return (
    <div className='page-body'>
        <DropdownContainer/>
    </div>
  )
}
